// frontend\src\pages\Calculators\components\Exposure\constants.js
export const COMMON_APERTURES = [1, 1.4, 2, 2.8, 4, 5.6, 8, 11, 16, 22, 32];

export const STANDARD_SHUTTER_SPEEDS = [
  1/8000, 1/4000, 1/2000, 1/1000, 1/500, 
  1/250, 1/125, 1/60, 1/30, 1/15, 
  1/8, 1/4, 1/2, 1, 2, 4, 8, 15, 30
];
